export const SPECIALTIES = [
  { key: "attorney", label: "Attorney", plural: "Attorneys" },
  { key: "cpa", label: "CPA", plural: "CPAs" },
  { key: "banker", label: "Banker", plural: "Bankers" },
  { key: "wealth_advisor", label: "Wealth advisor", plural: "Wealth advisors" },
  { key: "insurance", label: "Insurance", plural: "Insurance" },
  { key: "consultant", label: "Consultant", plural: "Consultants" },
  { key: "other", label: "Other", plural: "Other" },
] as const;

export const SPECIALTY_LABELS: Record<string, string> = Object.fromEntries(SPECIALTIES.map((s) => [s.key, s.label]));

export const SPECIALTY_COLORS: Record<string, string> = {
  attorney: "bg-slate-100 text-slate-700 dark:bg-slate-900/30 dark:text-slate-400",
  cpa: "bg-teal-100 text-teal-700 dark:bg-teal-900/30 dark:text-teal-400",
  banker: "bg-blue-100 text-blue-700 dark:bg-blue-900/30 dark:text-blue-400",
  wealth_advisor: "bg-purple-100 text-purple-700 dark:bg-purple-900/30 dark:text-purple-400",
  insurance: "bg-indigo-100 text-indigo-700 dark:bg-indigo-900/30 dark:text-indigo-400",
  consultant: "bg-orange-100 text-orange-700 dark:bg-orange-900/30 dark:text-orange-400",
  other: "bg-gray-100 text-gray-700 dark:bg-gray-900/30 dark:text-gray-400",
};

/** "23 days ago · email", or "—" when never touched. */
export function touchLabel(t: { at: string; kind: string } | null, days: number | null): string {
  if (!t || days === null) return "—";
  const when = days === 0 ? "Today" : days === 1 ? "Yesterday" : `${days} days ago`;
  const kind = t.kind === "email" ? "email" : t.kind === "referral_sent" ? "referral" : t.kind;
  return `${when} · ${kind}`;
}
